module.exports = __webpack_public_path__ + "images/philanthropist-8e82874c66998af582400dea8e59788c.png";